export default [{
	titulo: 'Destaques',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/destaques',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]